import { chain } from 'icepick';
import queryString from 'query-string';
import log from '@atlassian/jira-common-util-logging/src/log';
import type { Location, RouterActionPush } from '@atlassian/react-resource-router';
import {
	QUERY_PARAM_ISSUE_PARENT_PANEL,
	QUERY_PARAM_VERSION_PANEL,
} from '../../../model/routing/constants';

export const removeLocationLegacyPanelQueryParameters = (
	location: Location,
	push: RouterActionPush,
) => {
	const search = chain({
		...queryString.parse(location.search),
	});
	const searchValue = search.value();
	let legacyPanelQueryParamRemoved = false;
	const { versionPanel, issueParentPanel } = searchValue;
	if (versionPanel) {
		search.unset(QUERY_PARAM_VERSION_PANEL);
		legacyPanelQueryParamRemoved = true;
	}
	if (issueParentPanel) {
		search.unset(QUERY_PARAM_ISSUE_PARENT_PANEL);
		legacyPanelQueryParamRemoved = true;
	}
	if (legacyPanelQueryParamRemoved) {
		const routerPayload = {
			...location,
			search: queryString.stringify(search.value()),
		};
		log.safeInfoWithoutCustomerData(
			'backlog.services.routing.legacy-panel-query-parameters',
			'Removed legacy panel query parameter(s)',
			{
				versionPanel,
				issueParentPanel,
			},
		);
		push(routerPayload);
	}
};
